<template>
  <CCard>
    <CCardHeader class="p-2 font-weight-bold" style="line-height: 2">
      상대습도
    </CCardHeader>
    <CCardBody class="p-2" v-if="emptyFlag"> 데이터 없음</CCardBody>
    <CCardBody class="p-2" :class="emptyFlag ? 'd-none' : ''">
      <div class="row-sensor">
        <div class="col-sensor">
          <div class="sensor-label" style="min-width: 110px">
            대기 중 수증기량
          </div>
          <div
            class="sensor-val"
            style="min-width: 70px; background: transparent; color: #3c4b64"
          >
            {{ sensor.absoluteHumidity }} g/m3
          </div>
        </div>
        <div class="col-sensor">
          <div class="sensor-label" style="min-width: 110px">현재 온도</div>
          <div
            class="sensor-val"
            style="min-width: 70px; background: transparent; color: #3c4b64"
          >
            {{ sensor.dryBulbTemp }} ℃
          </div>
        </div>
        <div class="col-sensor">
          <div class="sensor-label" style="min-width: 110px">포화 수증기량</div>
          <div
            class="sensor-val"
            style="min-width: 70px; background: transparent; color: #3c4b64"
          >
            {{ sensor.saturatedWaterVaporPressure }} g/m³
          </div>
        </div>
        <div class="col-sensor">
          <div class="sensor-label" style="min-width: 110px">이슬점 온도</div>
          <div
            class="sensor-val"
            style="min-width: 70px; background: transparent; color: #3c4b64"
          >
            {{ sensor.dewPointTemp }} ℃
          </div>
        </div>
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import store from "@/store";
import core from "@/core";
import TranspirationCalculator from "@/core/TranspirationCalculator";
import MixinsInEnvSensor from "@/mixins/in-env-sensor";

export default {
  name: "RelativeHumidityComponent",
  components: {},
  mixins: [MixinsInEnvSensor()],
  props: {
    properties: {
      type: Object,
      default: () => {
        return {
          initFlag: false,
          inEnvList: [],
        };
      },
    },
  },
  data() {
    return {
      app: store.state.app,
      emptyFlag: true,
      sensor: {
        list: [],
        value: "",
      },
      default: {
        sensor: {
          dryBulbTemp: 0,
          relativeHumidity: 0,
          absoluteHumidity: 0,
          dewPointTemp: 0,
          saturatedWaterVaporPressure: 0,
          hd: 0,
          hdColor: 0,
          vpd: 0,
          vpdColor: 0,
        },
      },
    };
  },
  mounted() {
    this.init();
    this.emptyFlag = false;
  },
  watch: {
    "properties.initFlag"(val) {
      console.log("initFlag");
      this.properties.initFlag = false;
      if (val) {
        this.init();
      }
    },
    "properties.inEnvList"() {
      console.log("inEnvList");
      this.redraw();
    },
  },
  methods: {
    init() {
      this.sensor = this.default.sensor;
    },
    redraw() {
      const list = this.properties.inEnvList;

      let lastDate = core.date.instance();
      if (list.length > 0) {
        const dataList = this.getFilterDataList(list, lastDate);
        if (dataList.length > 0) {
          this.sensor = dataList[dataList.length - 1].transpiration;
          this.emptyFlag = false;
        } else {
          this.emptyFlag = true;
        }
      } else {
        this.emptyFlag = true;
      }
    },
  },
};
</script>
